type BreadcrumbItem = {
  label: string | null | undefined;
  url?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export default function Breadcrumb({ items, className = "mt-2.5 mb-5" }: BreadcrumbProps) {
  const ArrowIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
      <path d="M4.6665 12.0811L8.75 7.99756L4.6665 3.91406L5.9165 2.66406L11.25 7.99756L5.9165 13.3311L4.6665 12.0811Z" fill="#ffffff" />
    </svg>
  );

  return (
    <section className={`section overflow-x-auto scrollbar-none relative z-1 ${className}`} data-html2canvas-ignore>
      <ul className="flex items-center justify-start gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className={`text-sm ${isLast ? "text-white line-clamp-1" : "text-white/60"}`}>
              {item.url && !isLast ? (
                <a href={item.url} className="flex items-center gap-1">
                  <span className={`${index === 0 ? "whitespace-nowrap" : "line-clamp-1"}`}>{item.label}</span>
                  <ArrowIcon />
                </a>
              ) : (
                <span className={`${index === 0 ? "whitespace-nowrap" : "line-clamp-1"}`}>{item.label}</span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
